import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconEmailRead(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M4 22c-.55 0-1.02-.196-1.412-.587A1.927 1.927 0 0 1 2 20V9.15c0-.35.083-.683.25-1 .167-.317.4-.567.7-.75l8.025-4.8c.167-.1.333-.171.5-.213.167-.041.342-.062.525-.062s.358.02.525.062c.167.042.333.113.5.213l8.025 4.8c.3.183.533.433.7.75.167.317.25.65.25 1V20c0 .55-.196 1.021-.587 1.413A1.928 1.928 0 0 1 20 22H4Zm8-8.525c.083 0 .167-.008.25-.025a.787.787 0 0 0 .25-.1L19.8 9l-7.3-4.35a.786.786 0 0 0-.25-.1 1.272 1.272 0 0 0-.5 0 .786.786 0 0 0-.25.1L4.2 9l7.3 4.35c.083.05.167.083.25.1.083.017.167.025.25.025ZM4 20h16v-8.8l-6.975 4.175c-.167.1-.333.175-.5.225-.167.05-.342.075-.525.075s-.358-.025-.525-.075a2.205 2.205 0 0 1-.5-.225L4 11.2V20Zm0 0h16H4Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
